import { render, staticRenderFns } from "./CopyableInput.vue?vue&type=template&id=083be8c5&scoped=true"
import script from "./CopyableInput.vue?vue&type=script&lang=js"
export * from "./CopyableInput.vue?vue&type=script&lang=js"
import style0 from "./CopyableInput.vue?vue&type=style&index=0&id=083be8c5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083be8c5",
  null
  
)

export default component.exports